import * as React from "react";
import { TableCell } from "@mui/material";
import { DataTable, type DataTableColumn } from "./DataTable";

export interface ConfigurationRow {
  key: string;
  value: string;
}

interface ConfigurationTableProps {
  rows: ConfigurationRow[];
}

/** Generic read-only key/value configuration table, built on the shared `DataTable`. Never edits or persists anything. */
export function ConfigurationTable({ rows }: ConfigurationTableProps): React.JSX.Element {
  const columns: Array<DataTableColumn<ConfigurationRow>> = [
    {
      key: "key",
      label: "Key",
      sortable: true,
      sortValue: (row) => row.key,
      render: (row) => <TableCell key="key">{row.key}</TableCell>,
    },
    {
      key: "value",
      label: "Value",
      render: (row) => <TableCell key="value">{row.value}</TableCell>,
    },
  ];

  return (
    <DataTable
      ariaLabel="Configuration"
      columns={columns}
      rows={rows}
      getRowKey={(row) => row.key}
    />
  );
}
